module.exports = __webpack_public_path__ + "static/media/pneumo.6ebda4d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/pneumo.jpg
// module id = 347
// module chunks = 0